export const PRICING_VISA_MASTER = 'Visa, Mastercard and Discover Credit';
export const PRICING_VISA_MASTER_DEBIT = 'Visa, Mastercard, Discover and Signature Debit';
